var CONFIG_API_HOST = 'https://apps.tongshike.cn'
var HOMEWORKLIST_HOST = 'https://www.tongshike.cn/umooc/tutorv2/homework.do?operation=filterClassHomeworkList'
var STUHOMEWORKLIST_HOST = 'https://www.tongshike.cn/umooc/learner/homework.do?operation=homeworkList'
if (window.location.href.indexOf('.ulearning.cn') !== -1) {
  CONFIG_API_HOST = 'https://apps.ulearning.cn'
  HOMEWORKLIST_HOST = 'https://www.ulearning.cn/umooc/tutorv2/homework.do?operation=filterClassHomeworkList'
  STUHOMEWORKLIST_HOST = 'https://www.ulearning.cn/umooc/learner/homework.do?operation=homeworkList'
}
// CONFIG_API_HOST = 'https://apps.ulearning.cn'
export const commonParams = {
  API_HOST: CONFIG_API_HOST,
  QINIU_RESOURCE_URL: 'https://tskcloud.ulearning.cn/',
  UPBASETORKEN_URL: 'https://oss.ulearning.cn',
  UPRESOURCE_URL: 'https://convert.ulearning.cn',
  HOMEWORKLIST_HOST: HOMEWORKLIST_HOST,
  STUHOMEWORKLIST_HOST: STUHOMEWORKLIST_HOST,
  BASE64_SAVEURL: 'https://up.qbox.me/putb64/-1',
  VIDEO_CONVERTADDR: 'https://convert.ulearning.cn/api/meidia/media2mp4/tskcloud',
  DOCCONVERSIONURL: 'https://convert.ulearning.cn/object/convert'
}



// WEBPACK FOOTER //
// ./src/common/config/config.js